import { KubernetesAiSavingsOpportunity } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";
import { ResourceAdditionalDetailsMap } from "@/store/resource-details/utils/types/resourceAdditionalDetails";
import { listingPriceColumnDefField } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const getResourceDetailsFromKubernetesAiSavingsOpportunity = (
  opportunity: KubernetesAiSavingsOpportunity,
  enableBillingCostAndForecastedEOMForOpportunities?: boolean,
) => {
  const formatedForestedEOM = money(opportunity.forecasted_end_of_month);

  let details: ResourceAdditionalDetailsMap[] = [
    { title: "Resource Id", value: opportunity.resource_id ?? "" },
    { title: "Resource Type", value: opportunity.resource_type },
    { title: "Service", value: opportunity.service },
    { title: "Region", value: opportunity.region },
    {
      title: "Cluster",
      value: opportunity.cluster.name ?? opportunity.cluster.cluster_id ?? "",
    },
    {
      title: "Current Monthly Price",
      value: money(opportunity.current_monthly_price ?? 0),
    },
    {
      title: "Forecasted EOM",
      value:
        formatedForestedEOM !== "N/A"
          ? `~${formatedForestedEOM}`
          : formatedForestedEOM,
    },
    {
      title: "Billing Cost",
      value: money(opportunity.billing_cost?.total),
    },
    {
      title: "Listing Price",
      value: {
        customComponentIdentifier: listingPriceColumnDefField,
        customComponentProps: {
          listing_price: opportunity.listing_price,
        },
      },
    },
    {
      title: "Estimated Cost After Savings",
      value: money(opportunity.estimated_monthly_price ?? 0),
    },
  ];

  if (!enableBillingCostAndForecastedEOMForOpportunities) {
    details = details.filter(({ title }) => {
      return !["Billing Cost", "Forecasted EOM", "Listing Price"].includes(
        title,
      );
    });
  }

  return details;
};
